import factory from './@impl/countdown-indicator.jsx';
import { func, number } from 'prop-types';
import scopeLogger from 'lib/scope-logger.js';

const console = scopeLogger('RMI:countdown-indicator');

const CountdownIndicator = factory({ console });

CountdownIndicator.propTypes = {
  timeout: number,
  width: number,
  height: number,
  borderRadius: number,
  strokeWidth: number,
  onComplete: func,
};

export { CountdownIndicator };
